// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import {
  MintRequest,
  MintRequest_Reject,
} from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Mint';
import { ContractId } from '@daml/types';
import { ERR_REJ_MINT, SUC_REJ_MINT } from '../../../../utils/strings';

interface Args {
  mintRequestId: ContractId<MintRequest>;
  reason?: string;
}

export const useRejectMintRequest2Step = () => {
  const { submit: rejectMintRequest } = useExerciseSubmission(
    MintRequest.MintRequest_Reject,
    SUC_REJ_MINT,
    ERR_REJ_MINT,
  );

  return async (args: Args) => {
    const { mintRequestId } = args;

    const payload: MintRequest_Reject = {
      reason: args.reason || '',
      extraArgs: null,
    };

    const disclosedContracts: never[] = [];

    await rejectMintRequest({
      cid: mintRequestId,
      argument: payload,
      meta: {
        disclosedContracts,
      },
    });
  };
};
